<template>
  <div id="totalBox">
    <div class="cultureBox">
      <p class="cultureTitle">企业文化</p>
      <p class="cultureTip">聚是一团火，散作满天星</p>
      <p class="cultureContent">打造“五型”特质公司(平台型公司、合伙型机制、创客型员工、教育型营销、虎狼型团队)</p>
      <div class="firstImg">
        <img src="../../assets/about/backImg.png" class="backImg" alt="" />
        <img src="../../assets/about/five.png" class="fiveImg"/>
      </div>
      <div class="secondImg">
        <div class="sixContent">
          <p class="sixTitle">团队“六脉神剑”</p>
          <p class="sixText">情怀如来佛&nbsp;&nbsp;&nbsp;&nbsp;信念唐三藏</p>
          <p class="sixText">行动孙悟空&nbsp;&nbsp;&nbsp;&nbsp;情趣猪八戒</p>
          <p class="sixText">忠诚沙和尚&nbsp;&nbsp;&nbsp;&nbsp;谦逊白龙马</p>
        </div>
        <img src="../../assets/about/six.png" class="sixImg"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Culture',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 850px;
}
.cultureBox{
  width: 1200px;
  height: 850px;
  margin: 0 auto;
  padding-top: 22px;
  text-align: left;
}
.cultureTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.cultureTip{
  font-size:24px;
  font-weight:400;
  color:rgba(35,24,21,1);
  margin-top: 10px;
}
.cultureContent{
  font-size:20px;
  font-weight:400;
  color:rgba(117,117,117,1);
  line-height:40px;
}
.firstImg{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
}
.backImg{
  width: 600px;
  height: 340px;
}
.fiveImg{
  width: 579px;
  margin-left: 43px;
}
.secondImg{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
}
.sixContent{
  width: 600px;
  height: 318px;
  background-color: #fefefef;
  padding-top: 76px;
}
.sixImg{
  width: 540px;
  height: 318px;
}
.sixTitle{
  font-size:28px;
  font-weight:bold;
  color:rgba(12,137,24,1);
  text-align: center;
  margin-bottom: 29px;
  padding-left: 30px;
}
.sixText{
  text-align: center;
  font-size:20px;
  font-weight:400;
  color:rgba(35,24,21,1);
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/culture.vue